module.exports = __webpack_public_path__ + "img/shape-bg.7b990e1a.png";